import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LiliTooltip, LiliToolTipColor, Text, TooltipPosition } from '@lili/lili-frontend-common';
import { Icon, Icons } from '@Components/icon/Icon';

import { OnboardingFormFields } from '@Types/types';
import { ControlledCheckboxNew } from '@Components/index';
import { reportOnlyOwner } from '../OwnersCenterAnalytics';
import { UBO_INDEX_TO_FIELD_NAME } from '../ownersCenter.consts';
import { useOwnersCenterContext } from '../context/OwnersCenterContext';
import { UboItem } from './UboItem';
import type { UboResponse } from '@Store/index';
import type { OwnersCenterFormType } from '../OwnersCenterForm/OwnersCenterForm.types';

export interface UBOManagementProps {
  uboList: UboResponse[];
  hasMoreThan25PercentOwnershipLeft: boolean;
}

export const UBOManagement = ({
  uboList,
  hasMoreThan25PercentOwnershipLeft,
}: UBOManagementProps) => {
  const { control } = useFormContext<OwnersCenterFormType>();
  const { t } = useTranslation();
  const { onAddClick } = useOwnersCenterContext();

  const handleCheckboxChange = (value: boolean) => {
    if (uboList?.length > 1) return;
    reportOnlyOwner(value);
  };

  return (
    <>
      {uboList.map((ubo, index) => (
        <UboItem
          key={ubo.externalId}
          index={index}
          ubo={ubo}
          name={UBO_INDEX_TO_FIELD_NAME[index]}
        />
      ))}

      <div className='flex flex-col gap-[40px]'>
        <button
          type='button'
          className='flex items-center gap-[2px] w-fit'
          disabled={!hasMoreThan25PercentOwnershipLeft}
          data-tooltip-id='tooltip-add-owner-disabled'
          data-testid='add-owner-button'
          onClick={onAddClick}>
          <span
            className={`${hasMoreThan25PercentOwnershipLeft ? 'text-text-brand-primary' : 'text-text-main-disabled'} w-4 h-4`}>
            <Icon icon={Icons.Plus} />
          </span>
          <Text.H10
            className={`${hasMoreThan25PercentOwnershipLeft ? 'text-text-brand-primary' : 'text-text-main-disabled'} underline`}>
            {t('pages.ownersCenter.addOwner')}
          </Text.H10>
        </button>
        {!hasMoreThan25PercentOwnershipLeft && (
          <LiliTooltip
            color={LiliToolTipColor.White}
            description={t('pages.ownersCenter.addOwnerDisabledTooltip')}
            position={TooltipPosition.TOP}
            targetId='tooltip-add-owner-disabled'
          />
        )}

        <ControlledCheckboxNew
          control={control}
          name={OnboardingFormFields.OWNER_CENTER_CONSENT}
          id='elCheckbox'
          props={{
            label: t('pages.ownersCenter.concent'),
            labelTextColor: 'text-text-main-secondary',
            containerClassName: 'mt-[2px]',
            labelAlign: 'start',
          }}
          handleOnChange={handleCheckboxChange}
        />
      </div>
    </>
  );
};
